import type { $Fetch } from "ofetch";

/** Corpo esperado pelo endpoint de consulta ao banco Medware. */
export interface ConsultaDbRequest {
  query: string;
}

/** Metadados de uma coluna retornada pela consulta. */
export interface ConsultaDbColuna {
  coluna: string;
  tipo: string;
}

/** Linha dinâmica retornada pela consulta SQL. */
export type ConsultaDbLinha = Record<string, unknown>;

/** Resultado completo de uma consulta ao banco Medware. */
export interface ConsultaDbResponse {
  colunas: ConsultaDbColuna[];
  dados: ConsultaDbLinha[];
}

/** Estrutura de erro devolvida pela API no padrão ProblemDetails. */
export interface ConsultaDbProblemDetails {
  status: number;
  title: string;
  detail: string;
  [propriedade: string]: unknown;
}

/** Prefixo das rotas disponibilizadas pelo controller Medware. */
const controller = "/Medware";

/** Gerencia as chamadas aos endpoints do domínio Medware. */
export default class MedwareApi {
  /** Cria o cliente do domínio Medware com a instância HTTP global. */
  constructor(private readonly api: $Fetch) {}

  /**
   * Executa uma consulta de leitura no banco Medware.
   * @param request Consulta SQL no formato aceito pela API.
   * @returns Metadados das colunas e linhas encontradas.
   */
  executarConsultaDb(request: ConsultaDbRequest) {
    return this.api<ConsultaDbResponse>(`${controller}/ConsultaDB/Executar`, {
      method: "POST",
      body: request,
    });
  }
}
